import { Component, input, computed, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-text',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './app-text.component.html',
  styleUrl: './app-text.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppTextComponent {
  // Input signals - modern Angular approach
  text = input<string>('');
  size = input<'xs' | 'sm' | 'base' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | '6xl'>('base');
  weight = input<'light' | 'normal' | 'medium' | 'semibold' | 'bold'>('normal');
  color = input<'primary' | 'secondary' | 'default' | 'white' | 'black' | 'brand'>('default');
  align = input<'left' | 'center' | 'right'>('left');
  italic = input<boolean>(false);
  underline = input<boolean>(false);
  truncate = input<boolean>(false);

  // Computed signal for CSS classes - using input signals directly
  textClasses = computed(() => {
    const classes = [
      `text-${this.size()}`,
      `font-${this.weight()}`,
      `text-${this.align()}`,
    ];

    // Color classes
    switch (this.color()) {
      case 'primary':
        classes.push('text-black');
        break;
      case 'secondary':
        classes.push('text-gray-600');
        break;
      case 'white':
        classes.push('text-white');
        break;
      case 'black':
        classes.push('text-black');
        break;
      case 'brand':
        classes.push('text-brand-orange');
        break;
      default:
        classes.push('text-gray-900');
    }

    // Additional styles
    if (this.italic()) classes.push('italic');
    if (this.underline()) classes.push('underline');
    if (this.truncate()) classes.push('truncate');

    return classes.join(' ');
  });
}